export const getCleanNumericalValue = (val, fallback = 0) => {
  if (val === null || val === undefined) {
    return fallback;
  }
  return val;
};
